export function parseRepoList(text) {
    return text.split(/[\n,]/).map((s) => s.trim()).filter(Boolean);
}
